import BlackJackUtility from "../../Utility/blackJack_utility";
import ModelData from "../../../public/model_data";
import Utility from "../../../../utility/utility";



const {ccclass, property} = cc._decorator;

@ccclass
export default class BlackjackSliderView extends cc.Component {
   
    

    @property(cc.Label)
    cionTxt: cc.Label = null;

    @property(cc.Sprite)
    Progress: cc.Sprite = null;

    @property(cc.Sprite)
    coinBg: cc.Sprite = null;

    @property(cc.Sprite)
    handle: cc.Sprite = null;
    
    @property(cc.Slider)
    slider: cc.Slider = null;

    @property(cc.SpriteAtlas)
    spriteAtlas: cc.SpriteAtlas = null

    @property(cc.Button)
    closeBtn: cc.Button = null
    
    dis=0
    minNum=1
    maxNum=100

    slideBetNum = 0
   
    
    start () {

        
        if(this.slider == null || this.Progress == null){
            return;
        }
        //删除isMangoTable的判断  modif by dred 
        this.Progress.spriteFrame=this.getSpriteFrameByName("progress2")
        this.handle.spriteFrame=this.getSpriteFrameByName("handle2")
        this.coinBg.spriteFrame=this.getSpriteFrameByName("coinBg2")


        this.Progress.fillRange = this.slider.progress;
        this.dis=this.maxNum-this.minNum
        this.slider.node.on('slide',this.sliderCallBack,this);
    }
    onLoad(){
        
        this.closeBtn.node.on('click', this.on_click, this)
    }
    protected on_click(event: cc.Button): boolean {

        let isClickValid = Utility.btnClickValid(100)
        if (!isClickValid) {
            return isClickValid
        }
        this.node.active=false;
    }
    showPanel(isShow:boolean)
    {
        if(this.maxNum==this.minNum)
        {
            this.slider.progress=1
            this.node.active=isShow;
            this.handle.node.active=false
            this.cionTxt.string=this.maxNum.toString();
            return
        }
        this.handle.node.active=true
        this.dis=this.maxNum-this.minNum
        this.node.active=isShow;
        this.slider.progress=0
        this.disposeSliderMove(0)
    }
    sliderCallBack(slider:cc.Slider){
        
        this.disposeSliderMove(slider.progress)
    }
    private disposeSliderMove(val){
        let v = parseInt((val * this.dis).toString())+this.minNum
        if (v<this.minNum || val==0) {
            v=this.minNum;
        }

        if (v>=this.maxNum|| val==1) {
            v=this.maxNum;
        }
        
        this.Progress.fillRange = this.slider.progress;
        this.slideBetNum = v
        let numb = BlackJackUtility.addThousands(v);
        this.cionTxt.string=numb;

    } 

     getSpriteFrameByName(key: string){
        return this.spriteAtlas.getSpriteFrame(key)
    }
   
}
